import { useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ModuleSpecResponse, ApiError } from '../types/showcase';

/**
 * Query: GET /api/eraf/catalog/modules/{code}/spec (queue #688 §UAT-2026-07-14-R688 §R688-5).
 * `ModuleDocsModal` 이 모달 open 시에만 `enabled: open` 로 활성화한다(lazy fetch — 트리 클릭만
 * 으로 143 노드 전체 요청이 나가는 사고 방지 · #655 OOM 계보 재발 방지). staleTime 은 BE 캐시
 * TTL(10분 · `catalog-module-spec`)과 정합.
 */
export function useModuleSpec(code: string, options: { enabled: boolean }) {
  return useQuery<ModuleSpecResponse, ApiError>({
    queryKey: ['module-spec', code],
    queryFn: () => showcaseApi.moduleSpec(code),
    enabled: options.enabled,
    retry: false,
    staleTime: 10 * 60_000,
  });
}
